import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NSGridModule } from '@norfolk-southern/accessns-components';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { FromTrackHeaderComponent } from '@ruby/modules/track-move/components/from-track-header/from-track-header.component';
import { ToTrackHeaderComponent } from '@ruby/modules/track-move/components/to-track-header/to-track-header.component';
import { TrackColumnHeaderComponent } from '@ruby/modules/track-move/components/track-column-header/track-column-header.component';
import { TrackFooterComponent } from '@ruby/modules/track-move/components/track-footer/track-footer.component';
import { TrackMoveComponent } from '@ruby/modules/track-move/components/track-move.component';
import { TrackSelectActionComponent } from '@ruby/modules/track-move/components/track-select-action/track-select-action.component';
import { FromTrackHeaderContainerComponent } from '@ruby/modules/track-move/containers/from-track-header/from-track-header.container';
import { ToTrackHeaderContainerComponent } from '@ruby/modules/track-move/containers/to-track-header/to-track-header.container';
import { TrackColumnHeaderContainerComponent } from '@ruby/modules/track-move/containers/track-column-header/track-column-header.container';
import { TrackMoveContainerComponent } from '@ruby/modules/track-move/containers/track-move.container';
import { TrackSelectActionContainerComponent } from '@ruby/modules/track-move/containers/track-select-action/track-select-action.container';
import { fromTrackMove, TrackMoveEffects } from '@ruby/modules/track-move/store';
import { TrackMoveRoutingModule } from '@ruby/modules/track-move/track-move-routing.module';
import { DirectivesModule } from '@ruby/shared/directives/directives.module';
import { GridPreferencesCustomService } from '@ruby/shared/services/grid-preferences-custom.service';

@NgModule({
  declarations: [
    FromTrackHeaderComponent,
    ToTrackHeaderComponent,
    TrackColumnHeaderComponent,
    TrackFooterComponent,
    TrackSelectActionComponent,
    TrackMoveComponent,
    FromTrackHeaderContainerComponent,
    ToTrackHeaderContainerComponent,
    TrackColumnHeaderContainerComponent,
    TrackSelectActionContainerComponent,
    TrackMoveContainerComponent
  ],
  imports: [
    CommonModule,
    DirectivesModule,
    EffectsModule.forFeature([TrackMoveEffects]),
    FormsModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatSelectModule,
    MatTooltipModule,
    NSGridModule.forRoot(GridPreferencesCustomService),
    StoreModule.forFeature(fromTrackMove.featureKey, fromTrackMove.reducer),
    SweetAlert2Module.forChild(),
    TrackMoveRoutingModule
  ],
  exports: [TrackMoveContainerComponent]
})
export class TrackMoveModule {}
